import { render } from "./ReportEstimatesChart.vue?vue&type=template&id=ffb3bfce&scoped=true"
import script from "./ReportEstimatesChart.vue?vue&type=script&lang=js"
export * from "./ReportEstimatesChart.vue?vue&type=script&lang=js"

import "./ReportEstimatesChart.vue?vue&type=style&index=0&id=ffb3bfce&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb3bfce"]])

export default __exports__